// @ts-nocheck
if (!customElements.get('shop-the-look-item')) {

class ShopTheLookItem extends HTMLElement {
    connectedCallback() {
        this.variantSelectors = this.querySelectorAll('select.stl-select');
        this.addButton = this.querySelector('.stl-item__add-btn');
        this.buttonText = this.addButton?.querySelector('span');

        // Current variant ID from Liquid
        this.variantId = this.dataset.variantId;

        // Read variant data from embedded JSON
        const jsonScript = this.querySelector('script.stl-variant-data');
        try {
            this.variantData = jsonScript ? JSON.parse(jsonScript.textContent) : [];
        } catch (e) {
            this.variantData = [];
        }

        // Track added state
        this.isAdded = false;

        // Variant change listeners
        this.variantSelectors.forEach((select) => {
            select.addEventListener('change', () => this.onVariantChange());
        });

        // Add to cart button
        if (this.addButton) {
            this.addButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.addToCart();
            });
        }

        // Listen for cart changes to reset Added state if item was removed
        this._onCartChange = () => this.checkCartForVariant();

        // Horizon events
        document.addEventListener('cart:update', this._onCartChange);
        document.addEventListener('cart:change', this._onCartChange);
        document.addEventListener('line-item:change', this._onCartChange);

        // Fallback events used by some themes
        document.documentElement.addEventListener('cart:refresh', this._onCartChange);
        document.documentElement.addEventListener('cart:updated', this._onCartChange);
    }

    disconnectedCallback() {
        document.removeEventListener('cart:update', this._onCartChange);
        document.removeEventListener('cart:change', this._onCartChange);
        document.removeEventListener('line-item:change', this._onCartChange);
        document.documentElement.removeEventListener('cart:refresh', this._onCartChange);
        document.documentElement.removeEventListener('cart:updated', this._onCartChange);
    }

    checkCartForVariant() {
        if (!this.isAdded) return;

        fetch('/cart.js')
            .then((res) => res.json())
            .then((cart) => {
                const stillInCart = cart.items.some(
                    (item) => String(item.variant_id) === String(this.variantId)
                );

                if (!stillInCart) {
                    this.isAdded = false;
                    this.addButton.classList.remove('stl-btn--added');
                    this.addButton.disabled = false;
                    this.buttonText.textContent = 'Add';
                }
            })
            .catch(() => {});
    }

    onVariantChange() {
        const selectedOptions = Array.from(this.variantSelectors).map((s) => s.value);

        const match = this.variantData.find((variant) => {
            return variant.options.every((opt, i) => selectedOptions[i] === opt);
        });

        // Reset added state when variant changes
        this.isAdded = false;
        this.addButton.classList.remove('stl-btn--added');

        if (match) {
            this.variantId = String(match.id);
            if (match.available) {
                this.addButton.disabled = false;
                this.buttonText.textContent = 'Add';
            } else {
                this.addButton.disabled = true;
                this.buttonText.textContent = 'Sold out';
            }
        } else {
            this.variantId = null;
            this.addButton.disabled = true;
            this.buttonText.textContent = 'Unavailable';
        }
    }

    addToCart() {
        if (!this.variantId || this.addButton.disabled || this.addButton.classList.contains('loading')) return;

        this.addButton.classList.add('loading');
        this.addButton.disabled = true;

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                items: [
                    {
                        id: parseInt(this.variantId, 10),
                        quantity: 1
                    }
                ]
            })
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.status) {
                    throw new Error(data.description || 'Error adding to cart');
                }

                // Mark as added — button stays in this state
                this.isAdded = true;
                this.buttonText.textContent = 'Added';
                this.addButton.disabled = false;
                this.addButton.classList.add('stl-btn--added');

                // Update Horizon cart drawer
                this.refreshHorizonCart();
            })
            .catch((err) => {
                console.error('STL add to cart error:', err);
                this.buttonText.textContent = 'Error';
                setTimeout(() => {
                    this.addButton.disabled = false;
                    this.buttonText.textContent = 'Add';
                }, 2000);
            })
            .finally(() => {
                this.addButton.classList.remove('loading');
            });
    }

    refreshHorizonCart() {
        // Method 1: Horizon's native CartUpdateEvent
        import('@theme/events')
            .then(({ CartUpdateEvent }) => {
                const cartDrawer = document.querySelector('cart-drawer-component');

                fetch('/cart.js')
                    .then((res) => res.json())
                    .then((cart) => {
                        const event = new CartUpdateEvent(cart, 'manual-trigger', {
                            itemCount: cart.item_count,
                            source: 'shop-the-look',
                            sections: {}
                        });
                        document.dispatchEvent(event);

                        if (cartDrawer?.hasAttribute('auto-open')) {
                            cartDrawer.open();
                        }
                    });
            })
            .catch(() => {
                // Fallback
                document.dispatchEvent(
                    new CustomEvent('cart:update', {
                        bubbles: true,
                        detail: {
                            data: {
                                itemCount: 1,
                                source: 'product-form-component'
                            }
                        }
                    })
                );

                document.documentElement.dispatchEvent(
                    new CustomEvent('cart:refresh', { bubbles: true })
                );
            });
    }
}

customElements.define('shop-the-look-item', ShopTheLookItem);

} // end guard